import { withRouter } from 'react-router';
import { compose, lifecycle, withHandlers, withProps } from 'recompose';

import withBaseUrl from '../../hoc/withBaseUrl';
import withProducts from '../../hoc/withProducts';
import { productsProviderV2 } from '../../hoc/productsProvider';
import categoriesAndBrandsProvider from '../../../hoc/categoriesAndBrandsProvider';
import withFetchTaxes from '../../../../main/settings/taxes/withFetchTaxes';

const SharedProductListContainer = compose(
  withRouter,
  withBaseUrl,
  productsProviderV2,
  categoriesAndBrandsProvider,
  withProducts,
  withProps(() => ({
    canSeeStockTaking: false,
    canSeeNewInventory: false,
    canSeeLowInventory: false,
  })),
  withFetchTaxes,
  lifecycle({
    componentDidMount() {
      this.props.fetchTaxes();
    },
  }),
  withHandlers({
    exportProductsToCsv: () => () => {
      throw new Error('"exportProductsToCsv" has to be explicitly implemented!');
    },
    exportLowInventoryToCsv: () => () => {
      throw new Error('"exportLowInventoryToCsv" has to be explicitly implemented!');
    },
    openProduct: props => item => props.router.push(`${props.baseUrl}/${item.id}/edit`),
  }),
);

export default SharedProductListContainer;
